import * as types from './mutation-types'

export const updateEventStatus = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.patch('update/'+ data.id +'/event/status', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const createEventStatus = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('store/event/status', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const deleteEventStatus = ({ commit }, id) => {

    return new Promise((resolve, reject) => {
        window.axios.get('delete/'+id+'/event/status').then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const getEventStatus = ({commit}, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/' + id + '/event/status').then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
